import React, { useState, useEffect } from 'react';
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import {config} from "../../shared/config";
import * as util from '../../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import ShowError from "../../shared/ShowError";
import { Col, Container, Row } from 'react-bootstrap';
import Laoding from '../../shared/Laoding';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputNumber } from 'primereact/inputnumber';
import NumberBox from '../../shared/NumberBox';

export default function WinAccountingParams(props) {
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [pricePerCleint, setPricePerCleint] = useState(0);
    const [pricePerVisitor, setPricePerVisitor] = useState(0);

    useEffect(() => {
        var params = {
            login:util.getLoginDto(), 
            ownerType:util.OwnerTypes.System, 
            ownerId:"", 
            names:[util.ParameterTypes.PricePerCleintForWinAccounting, util.ParameterTypes.PricePerVisitorForWinAccounting], 
        };
        var url = config.Server+`/basic/setting/parameters/get`;
        setLoading(true);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            setLoading(false);
            if(response.state === "ok"){
                response = response.data;
                for(var i=0;i<response.length;i++){
                    if(response[i].name == util.ParameterTypes.PricePerCleintForWinAccounting) setPricePerCleint(parseInt(response[i].value));
                    if(response[i].name == util.ParameterTypes.PricePerVisitorForWinAccounting) setPricePerVisitor(parseInt(response[i].value));
                }
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setLoading(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setLoading(false);
        });
    }, []);
    const onInputChanged = function(val, name){
        if(name == "pricePerCleint") setPricePerCleint(val);
        else if(name == "pricePerVisitor") setPricePerVisitor(val);
    }
    const checkDataEntry = function(){
        if(pricePerCleint <= 0){
            setErrorMessage(true);
            setErrorMessage("مبلغ به ازای هر دستگاه نصبی اضافه مشخص نشده است");
            return;
        }
        if(pricePerVisitor <= 0){
            setErrorMessage(true);
            setErrorMessage("مبلغ به ازای هر ویزیتور مشخص نشده است");
            return;
        }
        return true;
    }
    const saveItem = function(){
        if (!checkDataEntry()) return;
        var params = {
            login: util.getLoginDto(), 
            ownerType: util.OwnerTypes.System,
            ownerId:"",
            parameters:[
                {name:util.ParameterTypes.PricePerCleintForWinAccounting, value:String(pricePerCleint)},
                {name:util.ParameterTypes.PricePerVisitorForWinAccounting, value:String(pricePerVisitor)}
            ]
        };
        setSaving(true);
        var url = config.Server + `/basic/setting/parameters/save`;
        axios
        .post(url, params)
        .then(res => {
            var response = res.data;
            if (response.state === "ok") {
                setErrorMessage("با موفقیت ثبت گردید");
                setErorVisible(true);
                setSaving(false);
                //setRedirectUrl("/home")
            }
            else {
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
            }
        })
        .catch(error => {
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setSaving(false);
        });
    }

    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :loading?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <Laoding showLable={true} label="در حال دریافت پارامترها..." />
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
        :
        <>
            <div style={{textAlign:"center", padding:"5px", backgroundColor:"#ccc", marginTop:"10px", borderTopRightRadius:"5px", borderTopLeftRadius:"5px"}}>
                تنظیم پارامترهای قیمت برای حسابداری ویندوزی
            </div>
            <table style={{width:"350px", margin:"0px auto"}}>
                <tbody>
                    <tr>
                        <td style={{textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>مبلغ به ازای هر دستگاه نصبی اضافه</td>
                        <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                            <NumberBox seperate={true} value={pricePerCleint} onChange ={(val) => {onInputChanged(val, "pricePerCleint")}} width={120} />
                        </td>
                    </tr>
                    <tr>
                        <td style={{textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>مبلغ به ازای هر ویزیتور</td>
                        <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                            <NumberBox seperate={true} value={pricePerVisitor} onChange ={(val) => {onInputChanged(val, "pricePerVisitor")}} width={120} />
                        </td>
                    </tr>
                </tbody>
            </table> 
            <Row style={{padding:"0px", margin:"20px 0px 0px 0px", position:"relative"}}>                
                <Col className="d-flex justify-content-center align-items-center" style={{marginBottom:"150px"}}>
                    <Button severity="success" onClick={()=>{saveItem()}} style={{borderRadius:"5px"}} loading={saving} iconPos="right" icon="pi pi-check">&nbsp;&nbsp;ثبت پارامترها&nbsp;&nbsp;</Button>
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    )
}